module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/management-f4e08910c7d8eb39760f1ab2f2a06141.webp";